import { render, staticRenderFns } from "./ImgUploadTab.vue?vue&type=template&id=180247fc"
import script from "./ImgUploadTab.vue?vue&type=script&lang=js"
export * from "./ImgUploadTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports